require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-6-xd-c-yvt-td-x-dw-wcam-i-5-fdsq.json") })
        }
      }, "path---news-c-6-xd-c-yvt-td-x-dw-wcam-i-5-fdsq");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-6-xd-c-yvt-td-x-dw-wcam-i-5-fdsq!./.cache/json/news-c-6-xd-c-yvt-td-x-dw-wcam-i-5-fdsq.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-6-xd-c-yvt-td-x-dw-wcam-i-5-fdsq!./.cache/json/news-c-6-xd-c-yvt-td-x-dw-wcam-i-5-fdsq.json
// module chunks = 231608221292675